<template>
    <v-select
        :items="items"
        :label="label"
        :hint="hint"
        :readonly="readonly"
        :value="value"
        :rules="requiredRules"
        item-text="credentialName"
        @change="changeItem"
        @input="changeItem"
        >
        <template v-slot:no-data>
          {{$t('warnings.no_data_found')}}
        </template>
    </v-select>
</template>
<script>

import CredentialsService from '../../services/CredentialsService'
import { requiredRules } from '../../utils/rules'

export default {

  name: 'CredentialSelect',

  methods: {
    changeItem (event) {
      this.$emit('change', event)
    }
  },

  data: () => ({
    items: []
  }),

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    requiredRules () { return this.required ? requiredRules(this.value) : [] }
  },

  mounted () {
    if (this.type === null || !this.type) {
      this.items = []
    } else {
      CredentialsService.findByType(this.type)
        .then(response => {
          if (response && response.data) {
            this.items = response.data
          } else {
            this.items = []
          }
        })
        .catch(error => {
          console.error(`${this.$t('warnings.error.occurred')} : ${error}`)
        })
    }
  }
}
</script>
